import { tv } from '~/utils/tv'

export const ContentActionsVariants = tv({
  base: `
   justify-end flex-shrink-0
  `,
  variants: {},
})
